import React, { useState } from "react";
import TopHeader from "./nav_top.js";

import UserReport from "./_200_user_report.js";
import CurrentUsers from "./_112_recent_logged_in_users.js"; 
import IndexPerCapture from "./_50_index_per.js";

import "./styles.css";

const MODULE_NAME = "labs_pg";

const activeDate = new Date().toLocaleDateString("en-US"); // MM/DD/YY
const screen = "labs_pg";
const sessionUserId = sessionStorage.getItem("user_id") ? Number(sessionStorage.getItem("user_id")) : null;
const userId = sessionUserId;

/**
 * labs_pg Component
 * This component displays the tagging center with trade tag management.
 */
const labs_pg = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [currentScreen, setScreen] = useState(screen);

  const handleNavigate = (destination) => {
    console.log("Navigate to:", destination);
    setScreen(destination);
  };

  const triggerRefresh = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (

      <div style={{ width: "100%" }} data-analytics={MODULE_NAME}>
          <TopHeader
              userId={userId}
              screen={screen}
              refreshKey={refreshKey}
              onNavigate={setScreen}
              hidden={true}

          />
          <CurrentUsers
              onNavigate={handleNavigate}
              screen={currentScreen}
              activeDate={activeDate}
              refreshKey={refreshKey}
          />
          <IndexPerCapture
              onNavigate={handleNavigate}
              screen={currentScreen}
              activeDate={activeDate}
              refreshKey={refreshKey}
          />
          <UserReport
          onNavigate={handleNavigate}
          screen={currentScreen}
          activeDate={activeDate}
          refreshKey={refreshKey}
          />


      </div>
   
  );
};

export default labs_pg;